import {ActivatedRoute, Router} from "@angular/router";
import {Component} from "@angular/core";
import {PaiementStore} from "./paiement.store";

@Component({
  template: ''
})
export class BackComponent {

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private paiementStore: PaiementStore) {

    activatedRoute.params.subscribe(params => {
      console.error("PAIEMENT KEY: " + params['paiementKey']);
      paiementStore.setPaiementKey(params['paiementKey']);
      router.navigate(['..'], {
        relativeTo: activatedRoute,
        replaceUrl: true
      });
    });

  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/back.component.ts